<p-dialog [(visible)]="visible" [modal]="true" [maximizable]="true" [style]="{ width: '96vw', height: '92vh' }"
  [contentStyle]="{
    height: '100%',
    display: 'flex',
    'flex-direction': 'column',
    overflow: 'hidden'
  }" styleClass="document-review-dialog" [closable]="true" [dismissableMask]="false" (onHide)="cancel()">

  <!-- =========================================================
       HEADER
  ========================================================== -->
  <ng-template pTemplate="header">

    <div class="review-dialog-header">

      <div class="review-header-icon">
        <i class="fa-solid fa-file-pen"></i>
      </div>

      <div class="review-header-content">

        <h2>Review & Edit Document</h2>

        <p>
          Review the extracted information and make any necessary
          changes before continuing.
        </p>

      </div>

      @if (!loading && !errorMessage && rows.length > 0) {

      <div class="review-header-status">
        <span class="status-dot"></span>

        {{ rows.length }}
        {{ rows.length === 1 ? 'row' : 'rows' }}
      </div>

      }

    </div>

  </ng-template>


  <!-- =========================================================
       LOADING
  ========================================================== -->
  @if (loading) {

  <div class="review-state loading-state">

    <div class="loading-icon">
      <i class="fa-solid fa-file-circle-check"></i>
    </div>

    <p-progressSpinner styleClass="review-spinner" strokeWidth="4"></p-progressSpinner>

    <div class="state-content">

      <h3>Preparing your document</h3>

      <p>
        We're converting and extracting your document data.
        This may take a moment.
      </p>

    </div>

  </div>

  }


  <!-- =========================================================
       ERROR
  ========================================================== -->
  @if (!loading && errorMessage) {

  <div class="review-state error-state">

    <div class="state-icon">
      <i class="fa-solid fa-triangle-exclamation"></i>
    </div>

    <div class="state-content">

      <h3>Something went wrong</h3>

      <p>
        {{ errorMessage }}
      </p>

    </div>

  </div>

  }


  <!-- =========================================================
       CONTENT
  ========================================================== -->
  @if (!loading && !errorMessage && rows.length > 0) {

  <!-- =======================================================
         TOOLBAR
    ======================================================== -->
  <div class="review-toolbar">

    <div class="toolbar-left">

      <div class="toolbar-title">

        <i class="fa-solid fa-table-cells"></i>

        <div>

          <strong>Extracted Data</strong>

          <span>
            Edit the cells directly below
          </span>

        </div>

      </div>

    </div>


    <div class="toolbar-right">

      <div class="toolbar-hint">

        <i class="fa-regular fa-lightbulb"></i>

        Click any cell to edit

      </div>


      <button pButton type="button" icon="pi pi-plus" label="Add Row" class="add-row-btn" (click)="addRow()"></button>

    </div>

  </div>


  <!-- =======================================================
         GRID
    ======================================================== -->
  <div class="excel-grid-container">

    <div class="grid-scroll-area scroll-bar">

      <p-table [value]="rows" dataKey="_id" editMode="cell" styleClass="review-data-table">

        <!-- =================================================
               TABLE HEADER
          ================================================== -->
        <ng-template pTemplate="header">

          <tr>

            <th class="row-number-header">
              <span>#</span>
            </th>


            <th class="title-header">

              <div class="table-header-content">

                <i class="fa-solid fa-heading"></i>

                <span>Title</span>

              </div>

            </th>


            <th class="content-header">

              <div class="table-header-content">

                <i class="fa-solid fa-align-left"></i>

                <span>Content</span>

              </div>

            </th>


            <th class="action-header"></th>

          </tr>

        </ng-template>


        <!-- =================================================
               TABLE BODY
          ================================================== -->
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">

          <tr [ngClass]="{
                'special-row': row._special,
                'normal-row': !row._special,
                'resources-row': row._special === 'resources'
              }">

            <!-- =============================================
                   ROW NUMBER
              ============================================== -->
            <td class="row-number-cell">

              <span>
                {{ rowIndex + 1 }}
              </span>

            </td>


            <!-- =============================================
                   TITLE
              ============================================== -->

            @if (row._special) {

            <td class="title-cell special-title-cell">

              <div class="special-label">

                <span class="special-icon">

                  @if (row._special === 'header') {

                  <i class="fa-solid fa-arrow-up"></i>

                  }
                  @else if (row._special === 'footer') {

                  <i class="fa-solid fa-arrow-down"></i>

                  }
                  @else if (row._special === 'resources') {

                  <i class="fa-solid fa-link"></i>

                  }
                  @else {

                  <i class="fa-solid fa-file"></i>

                  }

                </span>


                <span>
                  {{ row.title }}
                </span>

              </div>

            </td>

            }
            @else {

            <td class="title-cell editable-cell" [pEditableColumn]="row.title" pEditableColumnField="title">

              <p-cellEditor>

                <!-- TITLE INPUT -->
                <ng-template pTemplate="input">

                  <div class="cell-editor-wrapper">

                    <input type="text" class="excel-cell-input" [(ngModel)]="row.title" placeholder="Enter title..."
                      (keydown)="stopCellNav($event)" />

                  </div>

                </ng-template>


                <!-- TITLE OUTPUT -->
                <ng-template pTemplate="output">

                  <div class="cell-output">

                    <span>
                      {{ row.title || 'Untitled' }}
                    </span>

                  </div>

                </ng-template>

              </p-cellEditor>

            </td>

            }


            <!-- =============================================
                   CONTENT
              ============================================== -->

            @if (row._special === 'resources') {

            <td class="content-cell resources-content-cell">

              <div class="resource-list">

                @if (isResourceArray(getResources(row.content))) {

                @for (
                resource of getResources(row.content);
                track resource.url || resource.title || $index
                ) {

                <div class="resource-item">

                  <!-- ICON -->
                  <div class="resource-icon">
                    <i class="fa-solid fa-link"></i>
                  </div>


                  <!-- DETAILS -->
                  <div class="resource-details">

                    <div class="resource-title">
                      {{ resource.title || 'Untitled Resource' }}
                    </div>

                    @if (resource.url) {

                    <a class="resource-url" [href]="resource.url" target="_blank" rel="noopener noreferrer"
                      (click)="$event.stopPropagation()">
                      {{ resource.url }}
                    </a>

                    }
                    @else {

                    <span class="resource-no-url">
                      No URL available
                    </span>

                    }

                  </div>


                  <!-- OPEN -->
                  @if (resource.url) {

                  <a class="resource-open-btn" [href]="resource.url" target="_blank" rel="noopener noreferrer"
                    title="Open resource" (click)="$event.stopPropagation()">
                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                  </a>

                  }

                </div>

                }

                }
                @else {

                <div class="empty-resource">

                  <i class="fa-regular fa-folder-open"></i>

                  <span>
                    No resources found
                  </span>

                </div>

                }

              </div>

            </td>

            }
            @else {

            <!-- ===========================================
                     NORMAL CONTENT
                ============================================ -->
            <td class="content-cell editable-cell" [ngClass]="{
                    'special-content-cell': row._special
                  }" [pEditableColumn]="row.content" pEditableColumnField="content">

              <p-cellEditor>

                <!-- CONTENT INPUT -->
                <ng-template pTemplate="input">

                  <div class="cell-editor-wrapper content-editor">

                    <textarea class="excel-cell-textarea" rows="3" [(ngModel)]="row.content"
                      placeholder="Enter content..." (keydown)="stopCellNav($event)"></textarea>

                  </div>

                </ng-template>


                <!-- CONTENT OUTPUT -->
                <ng-template pTemplate="output">

                  <div class="cell-output content-output">

                    @if (row.content) {

                    <span>
                      {{ row.content }}
                    </span>

                    }
                    @else {

                    <span class="empty-cell">
                      No content
                    </span>

                    }

                  </div>

                </ng-template>

              </p-cellEditor>

            </td>

            }


            <!-- =============================================
                   ACTION
              ============================================== -->
            <td class="action-cell">

              @if (!row._special) {

              <button pButton type="button" icon="pi pi-trash" class="delete-row-btn" title="Remove row"
                (click)="removeRow(rowIndex)"></button>

              }

            </td>

          </tr>

        </ng-template>

      </p-table>

    </div>

  </div>

  }


  <!-- =========================================================
       EMPTY
  ========================================================== -->
  @if (!loading && !errorMessage && rows.length === 0) {

  <div class="review-state empty-state">

    <div class="state-icon">

      <i class="fa-solid fa-file-circle-xmark"></i>

    </div>

    <div class="state-content">

      <h3>No data found</h3>

      <p>
        No information could be extracted from this document.
      </p>

    </div>

  </div>

  }


  <!-- =========================================================
       FOOTER
  ========================================================== -->
  <ng-template pTemplate="footer">

    <div class="review-footer">

      <div class="footer-info">

        @if (
        !loading &&
        !errorMessage &&
        rows.length > 0
        ) {

        <div class="footer-status">

          <i class="fa-solid fa-circle-check"></i>

          <span>
            Changes are ready to be saved
          </span>

        </div>

        }

      </div>


      <div class="footer-actions">

        <button pButton type="button" label="Cancel" icon="pi pi-times" class="cancel-btn" [disabled]="saving"
          (click)="cancel()"></button>


        <button pButton type="button" [label]="saving ? 'Saving...' : 'Save & Continue'" [icon]="
            saving
              ? 'pi pi-spin pi-spinner'
              : 'pi pi-check'
          " class="save-btn" [disabled]="
            loading ||
            saving ||
            !!errorMessage ||
            rows.length === 0
          " (click)="save()"></button>

      </div>

    </div>

  </ng-template>

</p-dialog>
